import * as yup from "yup";

export const editProgrammeDescriptorValidation = () => {
  const schema = yup.object().shape({
    pdTitle: yup.string().label("This field").required().max(200),
    countries: yup
      .array()
      .of(yup.string())
      .min(1, "This field is required")
      .required("This field is required"),
    owner: yup.string().trim().required("This field is required"),
    language: yup.string().trim().required("This field is required"),
    resourceUpdated: yup
      .string()
      .nullable()
      .when("pdFile", {
        is: (pdFile) => !!pdFile && !!pdFile[0],
        then: (schema) =>
          schema
            .required(
              "Resource updated date is required when the file is modified"
            )
            .test(
              "valid-date",
              "Please enter a valid date",
              (value) => !value || !isNaN(new Date(value).getTime())
            ),
        otherwise: (schema) =>
          schema
            .notRequired()
            .test(
              "valid-date",
              "Please enter a valid date",
              (value) => !value || !isNaN(new Date(value).getTime())
            ),
      }),
    duration: yup
      .array()
      .of(yup.string())
      .min(1, "This field is required")
      .required("This field is required"),
    pdFile: yup
      .mixed()
      .test(
        "fileTypeValidation",
        "Only pdf/ppt file type is allowed",
        (file) => {
          const fileMIMETypeList = [
            "application/pdf",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          ];
          return (
            !file ||
            !file[0] ||
            (!!file[0] && fileMIMETypeList.includes(file[0].type))
          );
        }
      )
      .test(
        "fileSizeValidation",
        "The file size should be less than 20MB",
        (file) => {
          return (
            !file || !file[0] || (!!file[0] && file[0].size <= 20 * 1024 * 1024)
          );
        }
      ),
  });

  return { schema };
};
